// Extracted from enInbox.ts (file-length cap): the lead-priority and signal-priority filter labels
// every priority dropdown reads as `inbox.priorityFilterOptions.*` / `inbox.signalFilterOptions.*`.
// Spread back into the `inbox` namespace in enInbox.ts.
export const enInboxScoreFilters = {
	priorityFilterOptions: {
		ALL: "All qualified & disqualified leads",
		ALL_WITH_PRIORITY: "All qualified leads",
		P1: "Only Prio 1 leads",
		P2: "Only Prio 2 leads",
		P3: "Only Prio 3 leads",
		DQ: "Only Disqualified leads",
		UNSURE: "Only ? leads (no verdict)",
	},
	signalFilterOptions: {
		ALL: "All signals",
		ALL_WITH_SIGNAL: "All with signal score",
		S1: "Only Signal Prio 1",
		S2: "Only Signal Prio 2",
		S3: "Only Signal Prio 3",
		DQ: "Only Disqualified signals",
	},
};
